import { put } from 'redux-saga/effects';
import { ContactCompanyChangedEvent } from '../../../models/ContactCompany';
import { wsUpdateOrAddCompany } from '../actions';
import { Company } from '../../../models/Company';
import { CompanyType } from '../../../models/Types';

/**
 * The backend ContactCompanyChanged websocket payload still emits the old
 * PascalCase company type casing (e.g. "InternalCompany"), whereas the REST
 * API and the rest of the app use the new casing ("internalCompany") since the
 * enum-casing change (see commit ce234c85d). Without this normalization the
 * websocket-driven company replacement drops the company out of casing-based
 * filters (e.g. internalCompaniesSelector) until a hard reload re-fetches it.
 * Note: "ContactCompany" intentionally keeps its PascalCase casing.
 */
const COMPANY_TYPE_CASING_FIX: Record<string, CompanyType> = {
  InternalCompany: 'internalCompany',
  ExternalCompany: 'externalCompany',
};

const normalizeCompanyType = (company: Company): Company => {
  const fixedType =
    company && COMPANY_TYPE_CASING_FIX[company.companyType as string];
  return fixedType ? { ...company, companyType: fixedType } : company;
};

export function* handleCompanyChangedMessage(
  contactCompanyChangedEvent: ContactCompanyChangedEvent
) {
  yield put(
    wsUpdateOrAddCompany(
      normalizeCompanyType(contactCompanyChangedEvent.contactOrCompany as Company)
    )
  );
}
